import React, { useState, useEffect, useReducer, useRef, useMemo } from "react";
import {
  Card,
  CardContent,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  Tooltip,
  TableHead,
  TableRow,
  Input,
  TablePagination,
  Typography,
  IconButton,
  Button,
  Stack,
  Box,
} from "@mui/material";
import { DeviceNotesAlarmsColumns } from "./columns";
import DeleteIcon from "@mui/icons-material/Delete";
import { tlmDeleteDeviceNote } from "layouts/dashboard/apiService";
import NoData from "components/NoData";
import dayjs from "dayjs";
import { fetchAuthSession } from "aws-amplify/auth";
import { get } from "aws-amplify/api";
import currentUserToken from "CurrentUserToken";
import AddIcon from "@mui/icons-material/Add"; // Import dell'icona Add
import {
  tlmPostPinDeviceNote,
  tlmGetDeviceNoteAlarm,
} from "layouts/dashboard/apiService";
import { APIStatusDialog } from "components/APIStatusDialog";
import { I18n } from "@aws-amplify/core";
import PushPinOutlinedIcon from "@mui/icons-material/PushPinOutlined";
import PushPinIcon from "@mui/icons-material/PushPin";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { AddNewDeviceNoteDialogAlarm } from "popup/AddNewDeviceNoteDialogAlarm";
import { useRefresh } from "layouts/dashboard/RefreshContext";
const formatTimestamp = (timestamp) =>
  dayjs(timestamp).format("YYYY-MM-DD HH:mm:ss");
export const RenderDeviceNoteAlarm = ({
  devicePlantState,
  resourcePrefPage,
  rowsPerResourcePrefPage,
  setResourcePrefPage,
  setRowsPerResourcePrefPage,
  account_number,
  endDate,
  startDate,
  dispatchDevicePlant,
  setStartDate,
  setEndDate,
  profile,
  AlarmTypeID,
  OriginalEquipment,
  language,
}) => {
  const [apiStatus, setApiStatus] = useState({
    open: false,
    status: "",
    message: "",
  });
  const [userInfo, setUserInfo] = useState({
    email: "",
    name: "",
    profiles: ["NOT ADMIN"],
  });
  const normalizeEmail = (email) =>
    email
      .normalize("NFKC")
      .replace(/\u200B|\uFEFF/g, "")
      .replace(/[\u2010-\u2015\u2212\uFE63\uFF0D]/g, "-")
      .trim()
      .toLowerCase();
  const isGuest = profile && profile.includes("Guest"); // Check if profile includes "Guest"
  const isOperator = profile && profile.includes("Operator");
  const [tableParentIsMD, setTableParentIsMD] = useState(false);
  const toolbarRef = useRef(null);
  const {handleRefresh}=useRefresh();
  const formatTimestamp = (timestamp) =>
    dayjs(timestamp).format("YYYY-MM-DD HH:mm:ss");
  const handlePinClick = async (noteID, currentPinnedValue) => {
    const newPinnedValue = !currentPinnedValue;
    try {
      setApiStatus({
        open: true,
        status: "pending",
        message: I18n.get("Pinning"),
      });
      const restOperation = await tlmPostPinDeviceNote(noteID, newPinnedValue);
      const response = await restOperation.response;
      if (response.statusCode === 200) {
        setApiStatus({
          open: true,
          status: "success",
          message: I18n.get("Pinned successfully"),
        });
        const plantNoteResponse = await tlmGetDeviceNoteAlarm(
          account_number,
          endDate,
          startDate,
          AlarmTypeID,
          OriginalEquipment,
          language
        );
        dispatchDevicePlant({
          type: "DATA_RECEIVED",
          value: plantNoteResponse,
        });
      } else {
        setApiStatus({
          open: true,
          status: "error",
          message: I18n.get("Error Pinned"),
        });
      }
      setTimeout(() => {
        setApiStatus((prevState) => ({ ...prevState, open: false }));
      }, 2000);
      handleRefresh();
    } catch (error) {
      setApiStatus({
        open: true,
        status: "error",
        message: I18n.get("Error Pinned"),
      });
      setTimeout(() => {
        setApiStatus((prevState) => ({ ...prevState, open: false }));
      }, 2000);
    }
  };

  useEffect(() => {
    async function currentSession() {
      try {
        const { accessToken, idToken } =
          (await fetchAuthSession()).tokens ?? {};
        const profiles = await tlmGetUserGroups(
          idToken.payload["cognito:username"]
        );

        setUserInfo({
          name: idToken.payload.name || "No Name",
          email: idToken.payload.email || "No email",
          profiles: profiles || [],
        });

        // Save profiles to setProfile
      } catch (err) {}
    }

    currentSession();
  }, []);
  const tlmGetUserGroups = async (userID) => {
    try {
      const restOperation = get({
        apiName: "TelemonitoringAPI",
        path: "/userManagement/user/groups",
        options: {
          headers: {
            "Content-Type": "application/json",
            Authorization: `${await currentUserToken()}`,
          },
          queryParams: { user_id: userID },
        },
      });
      const { body } = await restOperation.response;
      const response = await body.json();

      // Extract profiles from the response and set groupNameSel with the first profile
      const profiles = response.profiles.map((profile) => profile.group_name);
      return profiles;
    } catch (error) {
      console.error("Error fetching user groups:", error);
    }
  };
  useEffect(() => {
    const parentElement = toolbarRef.current;
    if (!parentElement) {
      console.error("toolbarRef is not correctly attached to any DOM element.");
      return;
    }
    const checkSize = (width) => {
      const breakpoint = 960; // 960px is md
      setTableParentIsMD(width < breakpoint);
    };
    const resizeObserver = new ResizeObserver((entries) => {
      for (let entry of entries) {
        checkSize(entry.contentRect.width);
      }
    });
    resizeObserver.observe(parentElement);
    checkSize(parentElement.offsetWidth);
    return () => {
      resizeObserver.disconnect();
    };
  }, []);
  const [openAddDialog, setOpenAddDialog] = useState(false);
  const plantNotesColumns = DeviceNotesAlarmsColumns();
  const handleDeleteNote = async (noteID) => {
    try {
      setApiStatus({
        open: true,
        status: "pending",
        message: I18n.get("Deleting device note"),
      });
      const restOperation = await tlmDeleteDeviceNote(noteID);

      const response = await restOperation.response;
      if (response.statusCode === 200) {
        setApiStatus({
          open: true,
          status: "success",
          message: I18n.get("Device Note deleted successfully"),
        });
        // Re-fetch the plant notes after deletion
        const notesResponse = await tlmGetDeviceNoteAlarm(
          account_number,
          endDate,
          startDate,
          AlarmTypeID,
          OriginalEquipment,
          language
        );
        dispatchDevicePlant({ type: "DATA_RECEIVED", value: notesResponse });
      } else if (response.statusCode === 401) {
        setApiStatus({
          open: true,
          status: "error",
          message: I18n.get("Unauthorized user"),
        });
      } else {
        setApiStatus({
          open: true,
          status: "error",
          message: I18n.get("Error deleting device note"),
        });
      }

      setTimeout(() => {
        setApiStatus((prevState) => ({ ...prevState, open: false }));
      }, 2000);
      handleRefresh();
    } catch (error) {
      setApiStatus({
        open: true,
        status: "error",
        message: I18n.get("Error deleting device note"),
      });

      setTimeout(() => {
        setApiStatus((prevState) => ({ ...prevState, open: false }));
      }, 2000);
    }
  };

  if (!devicePlantState.data || devicePlantState.data.length === 0) {
    return (
      <Card>
        <CardContent sx={{ padding: "1rem" }}>
          <Stack
            spacing={2}
            direction={tableParentIsMD ? "column" : "row"}
            alignItems="center"
            // sx={{ pb: 2 }}
          >
            <Tooltip title="Add New Device Note">
              <IconButton
                onClick={() => setOpenAddDialog(true)}
                disabled={isGuest}
              >
                <AddIcon />
              </IconButton>
            </Tooltip>
            <Box
              sx={{
                ml: 2,
                flexGrow: 1,
                display: "flex",
                justifyContent: "flex-end",
              }}
            >
              <Typography variant="h5">
                {`${I18n.get("Device Note")} - ${
                  OriginalEquipment || I18n.get("No Equipment")
                }`}
              </Typography>
            </Box>
          </Stack>

          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <NoData />
          </Box>
        </CardContent>
        <AddNewDeviceNoteDialogAlarm
          open={openAddDialog}
          onClose={() => setOpenAddDialog(false)}
          accountNumber={account_number}
          dispatchDevicePlant={dispatchDevicePlant}
          startDate={startDate}
          endDate={endDate}
          AlarmTypeID={AlarmTypeID}
          OriginalEquipment={OriginalEquipment}
        />

        {/* API Status Dialog */}
        <APIStatusDialog
          open={apiStatus.open}
          status={apiStatus.status}
          message={apiStatus.message}
        />
      </Card>
    );
  }

  return (
    <Card>
      <CardContent sx={{ padding: "1rem" }}>
        <Stack
          spacing={2}
          direction={tableParentIsMD ? "column" : "row"}
          alignItems="center"
          paddingBottom="1rem"
        >
          <Tooltip title="Add New Device Note">
            <IconButton
              onClick={() => setOpenAddDialog(true)}
              disabled={isGuest}
            >
              <AddIcon />
            </IconButton>
          </Tooltip>
          <Box
            sx={{
              ml: 2,
              flexGrow: 1,
              display: "flex",
              justifyContent: "flex-end",
            }}
          >
            <Typography variant="h5">
              {`${I18n.get("Device Note")} - ${
                OriginalEquipment || I18n.get("No Equipment")
              }`}
            </Typography>
          </Box>
        </Stack>
        <TableContainer>
          <Table>
            <TableHead>
              <TableRow>
                {plantNotesColumns.map((column) => (
                  <TableCell key={column.id}>{column.label}</TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              {devicePlantState.data
                .slice(
                  resourcePrefPage * rowsPerResourcePrefPage,
                  resourcePrefPage * rowsPerResourcePrefPage +
                    rowsPerResourcePrefPage
                )
                .map((mappingRow, rowIndex) => {
                 
                  return(
                  <TableRow key={rowIndex}>
                    {plantNotesColumns.map((column, colIndex) => (
                      <TableCell key={colIndex} style={{ padding: "0px" }}>
                        {column.id === "timestamp" ? (
                          formatTimestamp(mappingRow[column.id]) // Formattazione qui
                        ) : column.id === "pinned" ? (
                          <Tooltip
                            title={
                              isGuest 
                                ? I18n.get("Unauthorized User")
                                : ""
                            }
                            arrow
                          >
                            <span>
                            <IconButton
                              onClick={() =>
                                handlePinClick(mappingRow.id, mappingRow.pinned)
                              }
                              disabled={
                                isGuest 
                                // ||
                                // normalizeEmail(userInfo.email) !==
                                // normalizeEmail(mappingRow.executor)
                              } // Disabilitato per utenti non autorizzati
                            >
                              {mappingRow.pinned ? (
                                <PushPinIcon />
                              ) : (
                                <PushPinOutlinedIcon />
                              )}
                            </IconButton>
                            </span>
                          </Tooltip>
                        ) : // Colonna "pinned" con il pulsante per gestire il pin

                        column.id === "action" ? (
                          // Colonna "action" con il pulsante di eliminazione
                          <Tooltip
                            title={
                              isGuest || ( isOperator && normalizeEmail(userInfo.email) !==
                              normalizeEmail(mappingRow.executor))
                                ? I18n.get("Unauthorized User")
                                : ""
                            }
                            arrow
                          >
                            <span>
                              <IconButton
                                onClick={() => handleDeleteNote(mappingRow.id)}
                                disabled={
                                  isGuest 
                                  || (isOperator &&
                                  normalizeEmail(userInfo.email) !==
                                  normalizeEmail(mappingRow.executor))
                                } // Disabilitato per utenti non autorizzati
                              >
                                <DeleteIcon /> {/* Icona di eliminazione */}
                              </IconButton>
                            </span>
                          </Tooltip>
                        ) : mappingRow[column.id] !== undefined &&
                          mappingRow[column.id] !== null ? (
                          mappingRow[column.id]
                        ) : (
                          ""
                        )}
                      </TableCell>
                    ))}
                  </TableRow>
                )})}
            </TableBody>
          </Table>
        </TableContainer>
        <TablePagination
          component="div"
          count={devicePlantState.data.length}
          page={resourcePrefPage}
          onPageChange={(event, newPage) => setResourcePrefPage(newPage)}
          rowsPerPage={rowsPerResourcePrefPage}
          onRowsPerPageChange={(event) => {
            setRowsPerResourcePrefPage(parseInt(event.target.value, 10));
            setResourcePrefPage(0);
          }}
          rowsPerPageOptions={[]}
        />
      </CardContent>

      {/* Dialogo per lo stato dell'API */}
      <APIStatusDialog
        open={apiStatus.open}
        status={apiStatus.status}
        message={apiStatus.message}
      />
      <AddNewDeviceNoteDialogAlarm
        open={openAddDialog}
        onClose={() => setOpenAddDialog(false)}
        accountNumber={account_number}
        dispatchDevicePlant={dispatchDevicePlant}
        startDate={startDate}
        endDate={endDate}
        AlarmTypeID={AlarmTypeID}
        OriginalEquipment={OriginalEquipment}
        language={language}
      />
    </Card>
  );
};
